/*
 * --------------------------------------------------------------------
 * File: \src\app\websocketSlice.js
 * Created: Monday, 7th October 2025
 * Author: System Consultancy Services Sdn. Bhd.
 * 
 * WebSocket Redux Slice - Manages WebSocket connection state and messages
 * --------------------------------------------------------------------
 */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isConnected: false,
  isConnecting: false,
  error: null,
  messages: [],
  lastMessage: null,
  reconnectAttempts: 0,
};

const websocketSlice = createSlice({
  name: "websocket",
  initialState,
  reducers: {
    setConnecting: (state) => {
      state.isConnecting = true;
      state.error = null;
    },
    setConnected: (state) => {
      state.isConnected = true;
      state.isConnecting = false;
      state.error = null;
      state.reconnectAttempts = 0;
    },
    setDisconnected: (state) => {
      state.isConnected = false;
      state.isConnecting = false;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.isConnecting = false;
      state.isConnected = false;
    },
    addMessage: (state, action) => {
      state.messages.push({
        ...action.payload,
        timestamp: Date.now(),
      });
      state.lastMessage = action.payload;
      // Keep only last 100 messages to prevent memory issues
      if (state.messages.length > 100) {
        state.messages = state.messages.slice(-100);
      }
    },
    clearMessages: (state) => {
      state.messages = [];
      state.lastMessage = null;
    },
    incrementReconnectAttempts: (state) => {
      state.reconnectAttempts += 1;
    },
    resetReconnectAttempts: (state) => {
      state.reconnectAttempts = 0;
    },
  },
});

export const {
  setConnecting,
  setConnected,
  setDisconnected,
  setError,
  addMessage,
  clearMessages,
  incrementReconnectAttempts,
  resetReconnectAttempts,
} = websocketSlice.actions;

export default websocketSlice.reducer;
